import {
  Box,
  CircularProgress,
  Dialog,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemText,
  TextField,
  Typography,
  Chip,
} from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import {
  default as Search,
  default as SearchIcon,
} from '@material-ui/icons/Search';
import axios from 'axios';
import AppButton from 'components/atoms/Button';
import { TranslatedTextV2 } from 'components/atoms/TranslatedText';
import { LanguagesEnum } from 'constants/languages';
import useDebounce from 'hooks/useDebounce';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import Actions from 'redux/reducers/gl_common_reducer/actions';
import * as Selectors from 'redux/reducers/gl_common_reducer/selectors';
import * as LanguageSelectors from 'redux/reducers/gl_translations_reducer/selectors';
import { requiredLogin } from '../../../../middlewares';
import useStyles from '../styles';
import { StateStatus } from 'redux/utils/common';
import Avatar from 'components/atoms/Avatar';
import { Environment } from 'config';
import { useHistory } from 'react-router';
import { TranslationKey } from '../configuration';

interface ISearchButtonProps {
  fullwidthMode?: boolean;
}

const SearchButton = ({ fullwidthMode = false }: ISearchButtonProps) => {
  const theme = useTheme();
  const classes = useStyles({});
  const dispatch = useDispatch();
  const history = useHistory();
  const [isOpen, setIsOpen] = useState(false);
  const [value, setValue] = useState('');
  const debouncedSearchTerm: string = useDebounce<string>(value, 1500);
  const languageID: LanguagesEnum = LanguageSelectors.useSelectLanguageID();
  const globalSearchFetch = Selectors.useGetGlobalSearch();

  const onClickOpen = () => {
    setIsOpen(true);
  };
  const handleClose = () => {
    setIsOpen(false);
  };
  // Effect for API call
  React.useEffect(
    () => {
      dispatch(
        Actions.fetchGlobalSearchAction({
          searchKeyWord: debouncedSearchTerm,
          language: languageID,
        })
      );
    },
    [debouncedSearchTerm] // Only call effect if debounced search term changes
  );
  function handleSearchChange(event: React.ChangeEvent<HTMLInputElement>) {
    setValue(event.target.value);
  }
  const onClickClient = (id: number) => {
    handleClose();
    history.push(`/clients/${id}/details`);
  };
  const onClickProduct = (id: number) => {
    handleClose();
    history.push(`/product/details/${id}`);
  };

  return (
    <>
      <AppButton
        // variant="text"
        // color="inherit"
        style={{
          backgroundColor: 'transparent',
          borderRadius: 48,
        }}
        color="primary"
        variant="outlined"
        fullWidth={fullwidthMode}
        startIcon={
          <SearchIcon
            color="inherit"
            style={{
              color: theme.palette.secondary.main,
              fontSize: 24,
            }}
          />
        }
        text={
          <Typography color="inherit">
            <TranslatedTextV2
              defaultText="Search"
              translationKey={`${TranslationKey}.search`}
            />
          </Typography>
        }
        onClick={onClickOpen}
      />
      <Dialog
        open={isOpen}
        fullWidth
        onClose={handleClose}
        scroll={'body'}
        className={classes.modalSearchGlobal}
      >
        <Box
          style={{
            textAlign: 'center',
            position: 'relative',
            padding: 20,
          }}
        >
          <Typography component="h2" style={{ fontSize: 22 }}>
            <TranslatedTextV2
              defaultText="Global seach"
              translationKey={`${TranslationKey}.global_search`}
            />
          </Typography>
          <IconButton
            style={{
              position: 'absolute',
              right: 10,
              top: 5,
            }}
            onClick={() => setIsOpen(false)}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        <Box className="box-search">
          <Box display="flex" justifyContent="space-between">
            <TextField
              autoFocus
              size="small"
              variant="outlined"
              value={value}
              style={{ height: 40, width: '100%' }}
              InputProps={{
                endAdornment: <Search />,
              }}
              onChange={handleSearchChange}
            />
          </Box>
          <Box>
            {globalSearchFetch.status === StateStatus.Pending ? (
              <Box
                style={{
                  height: '30vh',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <CircularProgress />
              </Box>
            ) : (globalSearchFetch?.data?.clients &&
                globalSearchFetch?.data?.clients?.length > 0) ||
              (globalSearchFetch?.data?.properties &&
                globalSearchFetch?.data?.properties?.length > 0) ? (
              <List
                style={{
                  cursor: 'pointer',
                  maxHeight: 400,
                  overflowY: 'auto',
                }}
              >
                {globalSearchFetch?.data?.clients.map((item, index: number) => {
                  return (
                    <ShowItem
                      key={index}
                      onClickClient={onClickClient}
                      id={item.id}
                      name={item.name}
                      email={item.email}
                      picture={item?.picture}
                      label={'Client'}
                    />
                  );
                })}
                {globalSearchFetch?.data?.properties.map(
                  (item, index: number) => {
                    return (
                      <ShowItem
                        key={index}
                        onClickClient={onClickProduct}
                        id={item.id}
                        name={item.name}
                        picture={item?.picture}
                        label={'Property'}
                      />
                    );
                  }
                )}
              </List>
            ) : (
              <Box
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  flexDirection: 'column',
                }}
              >
                <img
                  width={'50%'}
                  src={`${
                    require('assets/images/avatars/emptylist.png').default
                  }`}
                />{' '}
                <Box
                  style={{ width: '40%' }}
                  display={'flex'}
                  flexDirection={'column'}
                  alignItems={'center'}
                >
                  <Typography
                    style={{
                      fontWeight: 700,
                      fontSize: '20px',
                      lineHeight: '22px',
                      textAlign: 'center',
                      marginBottom: '16px',
                    }}
                  >
                    <TranslatedTextV2
                      translationKey={`${TranslationKey}.no_data`}
                      defaultText={'No data'}
                    />
                  </Typography>
                </Box>
              </Box>
            )}
          </Box>
        </Box>
      </Dialog>
    </>
  );
};

interface IShowItemProps {
  onClickClient: (id: number) => void;
  id: number;
  name: string;
  picture?: string | null;
  email?: string;
  label: string;
}

const ShowItem = ({
  onClickClient,
  id,
  name,
  picture,
  email,
  label,
}: IShowItemProps) => {
  return (
    <React.Fragment>
      <ListItem onClick={() => onClickClient(id)}>
        <Box
          style={{
            display: 'flex',
            alignItems: 'center',
            position: 'relative',
            width: '100%',
          }}
        >
          <Avatar
            name={name}
            image={`${Environment.API_BASE_URL}/${picture}`}
          />
          <Box style={{ marginLeft: 15 }}>
            <ListItemText primary={name} />
            {email && (
              <ListItemText
                style={{ fontWeight: 300, color: '#999' }}
                primary={`${email}`}
              />
            )}
            {!email && id && (
              <ListItemText
                style={{ fontWeight: 300, color: '#999' }}
                primary={`${id}`}
              />
            )}
          </Box>
          <Chip
            label={label}
            color="default"
            style={{
              position: 'absolute',
              right: 0,
            }}
          />
        </Box>
      </ListItem>
      <Divider />
    </React.Fragment>
  );
};

export default requiredLogin(SearchButton);
